export class HttpError extends Error {
    constructor(_resp) {
        super(_resp?.message ?? _resp?.status)
        this.code = _resp?.code ?? undefined
        this.headers = _resp?.headers
        this.resp = _resp
    }
}
